import {getStorageItem, StorageKeys} from './StorageHelper';
import format from 'date-fns/format';
import {parseJSON} from 'date-fns';

export const isEmpty = (obj: any): boolean => {
  if (obj === undefined || obj === null) return true;
  if (typeof obj === 'string') return obj.trim().length === 0;
  if (Array.isArray(obj)) return obj.length === 0;
  if (obj instanceof Set) return obj.size === 0;
  if (typeof obj === 'object') return Object.keys(obj).length === 0;
  return false;
};

export const isNotEmpty = (obj: any): boolean => !isEmpty(obj);

export const formatCurrency =  (amount: number, currency = '', abbreviate: boolean = undefined) => {

  if (abbreviate === undefined) {
    abbreviate = getStorageItem(StorageKeys.ABBREVIATE_CURRENCY);
  }

  let options: any = {
    maximumFractionDigits: 2,
  }

  if (currency) {
    options = {style: 'currency', currency, ...options}
  }

  if (abbreviate && amount >= 100000) {
    options = {notation: "compact", ...options}
  }

  return new Intl.NumberFormat('en-IN', options).format(amount);
};

export const defaultDateFormat = (date: Date): string => format(date, 'dd-MM-yyyy');

export const defaultDateFormatStr = (date: string): string => format(parseJSON(date), 'dd-MM-yyyy');
export const longDateFormatStr = (date: string): string => format(parseJSON(date), 'PPP pp');
